import React from 'react';
import { Box, VStack } from '@skin-seoul/design-system';
import { COLORS, SPACING } from './constants';
import { CompleteContainer, CompleteButton } from './SharedStyles';
import { Text } from '@skin-seoul/design-system';

const COMPLETION_CONTENT = {
  title: 'Thanks for your review!',
  description1: 'Your thoughts will help others find the perfect product.',
  description2: 'We truly appreciate you taking the time!',

  buttonText: 'Continue Shopping',
} as const;

const CompletionContent = () => (
  <VStack gap={4} align="start" w="full">
    <Text textStyle="paragraph.large" fontWeight="semibold" color="neutral.800">
      {COMPLETION_CONTENT.title}
    </Text>
    <Text textStyle="label.medium" color="neutral.600">
      {COMPLETION_CONTENT.description1}
    </Text>
    <Text textStyle="label.medium" color="neutral.600">
      {COMPLETION_CONTENT.description2}
    </Text>
  </VStack>
);

interface CompleteViewProps {
  onContinue: () => void;
  variant: 'pc' | 'mobile';
}

export const CompleteView = ({ onContinue, variant }: CompleteViewProps) => {
  const handleContinue = () => {
    onContinue();
    window.location.href = '/shop/';
  };

  if (variant === 'mobile') {
    return (
      <>
        <CompleteContainer
          style={{
            alignItems: 'flex-start',
            justifyContent: 'center',
            textAlign: 'left',
            paddingBottom: '80px',
          }}
        >
          <CompletionContent />
        </CompleteContainer>
        <Box
          position="fixed"
          left="0"
          right="0"
          bottom="0"
          w="full"
          bg={COLORS.background}
          p={`${SPACING.lg} ${SPACING.lg} 68px ${SPACING.lg}`}
          boxSizing="border-box"
        >
          <CompleteButton onClick={handleContinue}>
            <Text textStyle="paragraph.small" fontWeight="medium" color="generic.0">
              {COMPLETION_CONTENT.buttonText}
            </Text>
          </CompleteButton>
        </Box>
      </>
    );
  }

  return (
    <VStack gap={12} w="full">
      <CompletionContent />

      <CompleteButton onClick={handleContinue}>
        <Text textStyle="paragraph.small" fontWeight="medium" color="generic.0">
          {COMPLETION_CONTENT.buttonText}
        </Text>
      </CompleteButton>
    </VStack>
  );
};
